import "./Style.css";

export const PartitionLine = ({ style }) => {
  return (
    <div style={style}>
      <div className='partition-line'></div>
    </div>
  );
};
